// PROGRAMS
const GET_PROGRAMS_REQUEST = "GET_PROGRAMS_REQUEST";
const GET_PROGRAMS_COMPLETED = "GET_PROGRAMS_COMPLETED";
const GET_PROGRAMS_ERROR = "GET_PROGRAMS_ERROR";

const GET_ACTUAL_PROGRAMS_REQUEST = "GET_ACTUAL_PROGRAMS_REQUEST";
const GET_ACTUAL_PROGRAMS_COMPLETED = "GET_ACTUAL_PROGRAMS_COMPLETED";
const GET_ACTUAL_PROGRAMS_ERROR = "GET_ACTUAL_PROGRAMS_ERROR";

const GET_ACTUAL_PROGRAM_GROUPS_REQUEST = "GET_ACTUAL_PROGRAM_GROUPS_REQUEST";
const GET_ACTUAL_PROGRAM_GROUPS_COMPLETED = "GET_ACTUAL_PROGRAM_GROUPS_COMPLETED";
const GET_ACTUAL_PROGRAM_GROUPS_ERROR = "GET_ACTUAL_PROGRAM_GROUPS_ERROR";

const GET_PROGRAM_REQUEST = "GET_PROGRAM_REQUEST";
const GET_PROGRAM_COMPLETED = "GET_PROGRAM_COMPLETED";
const GET_PROGRAM_ERROR = "GET_PROGRAM_ERROR";

const GET_FULL_PROGRAM_REQUEST = "GET_FULL_PROGRAM_REQUEST";
const GET_FULL_PROGRAM_COMPLETED = "GET_FULL_PROGRAM_COMPLETED";
const GET_FULL_PROGRAM_ERROR = "GET_FULL_PROGRAM_ERROR";

const GET_PROGRAM_ANOUNCE_REQUEST = "GET_PROGRAM_ANOUNCE_REQUEST";
const GET_PROGRAM_ANOUNCE_COMPLETED = "GET_PROGRAM_ANOUNCE_COMPLETED";
const GET_PROGRAM_ANOUNCE_ERROR = "GET_PROGRAM_ANOUNCE_ERROR";

const GET_PROGRAM_DESCRIPTION_REQUEST = "GET_PROGRAM_DESCRIPTION_REQUEST";
const GET_PROGRAM_DESCRIPTION_COMPLETED = "GET_PROGRAM_DESCRIPTION_COMPLETED";
const GET_PROGRAM_DESCRIPTION_ERROR = "GET_PROGRAM_DESCRIPTION_ERROR";

//MODULES
const GET_MODULE_REQUEST = "GET_MODULE_REQUEST";
const GET_MODULE_COMPLETED = "GET_MODULE_COMPLETED";
const GET_MODULE_ERROR = "GET_MODULE_ERROR";

const GET_FULL_MODULE_REQUEST = "GET_FULL_MODULE_REQUEST";
const GET_FULL_MODULE_COMPLETED = "GET_FULL_MODULE_COMPLETED";
const GET_FULL_MODULE_ERROR = "GET_FULL_MODULE_ERROR";

const GET_MODULE_PURPOSE_REQUEST = "GET_MODULE_PURPOSE_REQUEST";
const GET_MODULE_PURPOSE_COMPLETED = "GET_MODULE_PURPOSE_COMPLETED";
const GET_MODULE_PURPOSE_ERROR = "GET_MODULE_PURPOSE_ERROR";

const GET_ORG_LIST_REQUEST = "GET_ORG_LIST_REQUEST";
const GET_ORG_LIST_COMPLETED = "GET_ORG_LIST_COMPLETED";
const GET_ORG_LIST_ERROR = "GET_ORG_LIST_ERROR";

const GET_EDU_FORM_LIST_REQUEST = "GET_EDU_FORM_LIST_REQUEST";
const GET_EDU_FORM_LIST_COMPLETED = "GET_EDU_FORM_LIST_COMPLETED";
const GET_EDU_FORM_LIST_ERROR = "GET_EDU_FORM_LIST_ERROR";

const GET_TARGET_GROUP_LIST_REQUEST = "GET_TARGET_GROUP_LIST_REQUEST";
const GET_TARGET_GROUP_LIST_COMPLETED = "GET_TARGET_GROUP_LIST_COMPLETED";
const GET_TARGET_GROUP_LIST_ERROR = "GET_TARGET_GROUP_LIST_ERROR";

const UPDATE_PROGRAM_LOGO_REQUEST = "UPDATE_PROGRAM_LOGO_REQUEST";
const UPDATE_PROGRAM_LOGO_COMPLETED = "UPDATE_PROGRAM_LOGO_COMPLETED";
const UPDATE_PROGRAM_LOGO_ERROR = "UPDATE_PROGRAM_LOGO_ERROR";

const UPDATE_PROGRAM_FILE_REQUEST = "UPDATE_PROGRAM_FILE_REQUEST";
const UPDATE_PROGRAM_FILE_COMPLETED = "UPDATE_PROGRAM_FILE_COMPLETED";
const UPDATE_PROGRAM_FILE_ERROR = "UPDATE_PROGRAM_FILE_ERROR";

const UPDATE_CERTIFICATE_FILE_REQUEST = "UPDATE_CERTIFICATE_FILE_REQUEST";
const UPDATE_CERTIFICATE_FILE_COMPLETED = "UPDATE_CERTIFICATE_FILE_COMPLETED";
const UPDATE_CERTIFICATE_FILE_ERROR = "UPDATE_CERTIFICATE_FILE_ERROR";

const ADD_NEW_PROGRAM_INFORMATION_REQUEST = "ADD_NEW_PROGRAM_INFORMATION_REQUEST";
const ADD_NEW_PROGRAM_INFORMATION_COMPLETED =
  "ADD_NEW_PROGRAM_INFORMATION_COMPLETED";
const ADD_NEW_PROGRAM_INFORMATION_ERROR = "ADD_NEW_PROGRAM_INFORMATION_ERROR";

const UPDATE_PROGRAM_INFORMATION_REQUEST = "UPDATE_PROGRAM_INFORMATION_REQUEST";
const UPDATE_PROGRAM_INFORMATION_COMPLETED =
  "UPDATE_PROGRAM_INFORMATION_COMPLETED";
const UPDATE_PROGRAM_INFORMATION_ERROR = "UPDATE_PROGRAM_INFORMATION_ERROR";

const DELETE_PROGRAM_REQUEST = "DELETE_PROGRAM_REQUEST";
const DELETE_PROGRAM_COMPLETED = "DELETE_PROGRAM_COMPLETED";
const DELETE_PROGRAM_ERROR = "DELETE_PROGRAM_ERROR";

const DELETE_PROGRAM_LOGO_REQUEST = "DELETE_PROGRAM_LOGO_REQUEST";
const DELETE_PROGRAM_LOGO_COMPLETED = "DELETE_PROGRAM_LOGO_COMPLETED";
const DELETE_PROGRAM_LOGO_ERROR = "DELETE_PROGRAM_LOGO_ERROR";

const DELETE_PROGRAM_FILE_REQUEST = "DELETE_PROGRAM_FILE_REQUEST";
const DELETE_PROGRAM_FILE_COMPLETED = "DELETE_PROGRAM_FILE_COMPLETED";
const DELETE_PROGRAM_FILE_ERROR = "DELETE_PROGRAM_FILE_ERROR";

const DELETE_CERTIFICATE_FILE_REQUEST = "DELETE_CERTIFICATE_FILE_REQUEST";
const DELETE_CERTIFICATE_FILE_COMPLETED = "DELETE_CERTIFICATE_FILE_COMPLETED";
const DELETE_CERTIFICATE_FILE_ERROR = "DELETE_CERTIFICATE_FILE_ERROR";

export default {
  GET_PROGRAMS_REQUEST,
  GET_PROGRAMS_COMPLETED,
  GET_PROGRAMS_ERROR,

  GET_ACTUAL_PROGRAMS_REQUEST,
  GET_ACTUAL_PROGRAMS_COMPLETED,
  GET_ACTUAL_PROGRAMS_ERROR,

  GET_ACTUAL_PROGRAM_GROUPS_REQUEST,
  GET_ACTUAL_PROGRAM_GROUPS_COMPLETED,
  GET_ACTUAL_PROGRAM_GROUPS_ERROR,

  GET_PROGRAM_REQUEST,
  GET_PROGRAM_COMPLETED,
  GET_PROGRAM_ERROR,
  GET_FULL_PROGRAM_REQUEST,
  GET_FULL_PROGRAM_COMPLETED,
  GET_FULL_PROGRAM_ERROR,
  GET_PROGRAM_ANOUNCE_REQUEST,
  GET_PROGRAM_ANOUNCE_COMPLETED,
  GET_PROGRAM_ANOUNCE_ERROR,
  GET_PROGRAM_DESCRIPTION_REQUEST,
  GET_PROGRAM_DESCRIPTION_COMPLETED,
  GET_PROGRAM_DESCRIPTION_ERROR,

  GET_MODULE_REQUEST,
  GET_MODULE_COMPLETED,
  GET_MODULE_ERROR,
  GET_FULL_MODULE_REQUEST,
  GET_FULL_MODULE_COMPLETED,
  GET_FULL_MODULE_ERROR,
  GET_MODULE_PURPOSE_REQUEST,
  GET_MODULE_PURPOSE_COMPLETED,
  GET_MODULE_PURPOSE_ERROR,
  GET_ORG_LIST_REQUEST,
  GET_ORG_LIST_COMPLETED,
  GET_ORG_LIST_ERROR,
  GET_EDU_FORM_LIST_REQUEST,
  GET_EDU_FORM_LIST_COMPLETED,
  GET_EDU_FORM_LIST_ERROR,
  GET_TARGET_GROUP_LIST_REQUEST,
  GET_TARGET_GROUP_LIST_COMPLETED,
  GET_TARGET_GROUP_LIST_ERROR,

  UPDATE_PROGRAM_LOGO_REQUEST,
  UPDATE_PROGRAM_LOGO_COMPLETED,
  UPDATE_PROGRAM_LOGO_ERROR,
  UPDATE_PROGRAM_FILE_REQUEST,
  UPDATE_PROGRAM_FILE_COMPLETED,
  UPDATE_PROGRAM_FILE_ERROR,
  UPDATE_CERTIFICATE_FILE_COMPLETED,
  UPDATE_CERTIFICATE_FILE_REQUEST,
  UPDATE_CERTIFICATE_FILE_ERROR,
  ADD_NEW_PROGRAM_INFORMATION_REQUEST,
  ADD_NEW_PROGRAM_INFORMATION_COMPLETED,
  ADD_NEW_PROGRAM_INFORMATION_ERROR,
  UPDATE_PROGRAM_INFORMATION_REQUEST,
  UPDATE_PROGRAM_INFORMATION_COMPLETED,
  UPDATE_PROGRAM_INFORMATION_ERROR,

  DELETE_PROGRAM_LOGO_REQUEST,
  DELETE_PROGRAM_LOGO_COMPLETED,
  DELETE_PROGRAM_LOGO_ERROR,
  DELETE_PROGRAM_FILE_REQUEST,
  DELETE_PROGRAM_FILE_COMPLETED,
  DELETE_PROGRAM_FILE_ERROR,
  DELETE_CERTIFICATE_FILE_REQUEST,
  DELETE_CERTIFICATE_FILE_COMPLETED,
  DELETE_CERTIFICATE_FILE_ERROR,
  DELETE_PROGRAM_REQUEST,
  DELETE_PROGRAM_COMPLETED,
  DELETE_PROGRAM_ERROR
}
